import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLolDrakeMountain = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.46747 0.5H8.34744L10.5497 2.93582L7.79638 9.46397H7.2115L4.45819 2.99677L6.46747 0.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0431 3.50832L13.5 5.69484V10.5646L8.1963 14.4852L7.92773 10.7936L11.0431 3.50832Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.98076 3.50832L1.50796 5.69484L1.5 10.5776L6.81365 14.5L7.10808 10.7936L3.98076 3.50832Z",
			fill: "currentColor"
		})
	]
});
export default SvgLolDrakeMountain;
